import { createContext } from 'react';
import { CourseType, CourseLearningOutcomeType, PartType } from '../types';

export interface CourseContextInterface {
  courseId?: number;
  course?: Partial<CourseType>;
  currentUser: {
    id: number;
  } | null;
  userToc?: PartType;
  nextChapter?: PartType;
  refetchTocData: () => void;
  refetchCourseData: () => void;
  flatToc?: Array<PartType>;
  description?: string;
  isLoadingUserToc?: boolean;
  learningOutcomes?: Array<CourseLearningOutcomeType>;
  isLoadingLearningOutcomes: boolean;
}

export default createContext<CourseContextInterface>({
  courseId: undefined,
  course: {
    learningActivityStatus: undefined,
    id: undefined,
    slug: undefined,
    category: undefined,
    categoryColor: undefined,
    categoryId: undefined,
    difficulty: undefined,
    displayDifficulty: undefined,
    duration: undefined,
    teaserUrl: undefined,
    title: undefined,
    illustration: undefined,
    userHasFollowedCourse: false,
    userIsFollowingCourse: false,
    userCourseCompletionRate: undefined,
    isActive: undefined,
    isPreregistrable: undefined,
    isSinglePage: undefined,
    shortDescription: undefined,
    OpenClassroomsUrl: undefined,
    type: undefined,
    nextChapterId: undefined,
    prerequisite: undefined,
  },
  nextChapter: undefined,
  currentUser: {
    id: undefined,
  },
  userToc: undefined,
  flatToc: undefined,
  refetchTocData: () => undefined,
  refetchCourseData: () => undefined,
  description: undefined,
  isLoadingUserToc: false,
  learningOutcomes: [],
  isLoadingLearningOutcomes: false,
});
